module.exports = __webpack_public_path__ + "img/excel.dcda0a50.svg";